<template>
  <main-content>
    <b-card>
      <ERegistrationHeaderFormInfo />
      <ERegistrationProfessionalActivateForm />
    </b-card>
  </main-content>
</template>

<script>
import ERegistrationProfessionalActivateForm from "../components/e-registration-professional-activate/ERegistrationProfessionalActivateForm";
import ERegistrationHeaderFormInfo from "../components/e-registration-header-form/ERegistrationHeaderFormInfo"

export default {
  components: {
    ERegistrationProfessionalActivateForm,
    ERegistrationHeaderFormInfo
  },
  mounted() {
    // 创建 MutationObserver 实例
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          const olElements = document.querySelectorAll('ol');
          olElements.forEach((ol) => {
            ol.childNodes.forEach((node) => {
              if (node.nodeName === 'BR') {
                ol.removeChild(node);
              }
            });
          });

          // 查找目标元素
          const scrollableDivs = document.querySelectorAll('.e-registration-public-term-cond__term-cond.card');
          if (scrollableDivs.length > 0) {
            // 遍历每个滚动区域并添加 tabindex 属性
            scrollableDivs.forEach((div) => {
              div.setAttribute('tabindex', '0');
            });
          }
        }
      })

    });
    // 开始监听 DOM 变化
    observer.observe(document.body, {
      childList: true, // 监听子节点的变化
      subtree: true,   // 监听后代节点
    });
    // 组件销毁时停止监听
    this.$once('hook:beforeDestroy', () => {
      observer.disconnect();
    });
  },
};
</script>

<style lang="scss" scoped></style>
